<style lang="scss">
	#warp_subs_from{
		display: flex;
		justify-content: space-between;
		.ant-col{
			margin-bottom: -.5rem;
		}
		.ant-input-disabled{
			color: #000;
			background-color: #fff;
			// border: 0;
		}
	}
	.mycol_div6{
		width: 24%;
		display: inline-block;
	}
	.id_nav{
		display: inline-block;
	}
	.id_nav .mydiv{
		width: 48%;
		margin-top: .5rem;
		display: inline-block;
	}
	#text_title{
		font-size: .8rem;
		color: #000;
		text-align: center;
		vertical-align: bottom;
		border-bottom: 1px solid #d8d8d8;
		border-top: 1px solid #d8d8d8;
		margin-bottom: 1rem;
		padding: .5rem 0;
		display: flex;
		justify-content: space-between;
	}
	#text_title>div{
		width: 24.4%;
		display: inline-block;
	}
	#text_title>div>div{
		width: 45%;
		display: inline-block;
	}
	#warp_sub, #warp_subs {
		.dateinput{
			width: 35% !important;
		}
		.valinput{
			width: 35% !important;
		}
		.warp_rightz {
			.ant-input {
				padding-right: 1rem !important;
			}
		}

		.ant-btn:hover,
		.ant-btn:focus {
			color: #0c8b96 !important;
			background-color: #fff;
			border-color: #0c8b96 !important;
		}



		.ant-input {
			height: 1.8rem;
			font-size: 0.8rem;
		}

		.ant-select-selection--single .ant-select-selection__rendered {
			height: 1.8rem;
			font-size: 0.8rem;
		}

		.ant-select-selection--single {
			height: 1.8rem;
			font-size: 0.8rem;
		}

		.ant-form label {
			font-size: .8rem;
		}

		.warp_button {
			width: 98%;
			margin: 0 auto;
			overflow: hidden;
		}

		.six_div>div{
			display: inline-block;
			margin-right: 2rem;
			font-size: .8rem;
		}
		.six_div{
			width: 70%;
		}
		
		.warp_a{
			width: 1.95rem;
			text-align: center;
			margin: 0;
			display: inline-block;
		}
		
		.texright{
			text-align: right;
			// margin-left: 4%;
		}
		.warp-right {
			float: right;
		}

		.ant-form-item-label {
			width: 15% !important;
		}
		.ant-form-item-control-wrapper{
			width: 85% !important;
			.wart-t{
				width: 100%;
			}
		}
		.warp_long {
			width: 50%;
			display: inline-block;
			
			.ant-form-item-label {
				width: 30% !important;
			}
			.ant-form-item-control-wrapper{
				width: 60% !important;
				
			}
		}
		.formItem{
			.ant-form-item-children{
				display: flex;
				justify-content: space-between;
			}
		}
		.warp_width {
			// width: 9rem;
		}

		.ant-form-item {
			margin-bottom: .6rem;
			width: 100% !important;
			margin-right: 0;
		}

		.qxBtn,
		.qdBtn {
			width: 9rem;
			height: 2.5rem;
			color: #fff;
			/* padding: 0.8rem 4rem; */
			outline: none;
			border: 0;
			border-radius: 5px;
			font-size: 0.8rem;
		}

		.qxBtn {
			background-color: #c8c8c8;
		}

		.qdBtn {
			background-color: #0c8b97;
			margin-left: auto;
		}

		.landen {
			.ant-form-item-label {
				white-space: pre-wrap;
				line-height: .8rem;
				padding: 0.3rem 0;
			}

			.ant-form label {
				font-size: .6rem;
			}
		}
	}

	#warp_sub .ant-form-explain {
		min-height: 0;
		display: none;
	}

	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#warp_sub .nonebor {
		position: relative;
		top: 3rem;
		text-align: right;

		div {
			display: inline-block;
			padding: 0 6px;
			cursor: pointer;
		}
	}
	#warp_sub .btnimg{
		border: 1px solid #d8d8d8;
		text-align: center;
		width: 100%;
		margin-right: .5rem;
		display: inline-block;
		height: 1.8rem;
		position: relative;
		top: 0.1rem;
		cursor: pointer;
	}
	#warp_sub .imgbtn{
		width: 1rem;
	}
</style>
<template>
	<div>
		<a-modal v-show='!ishand' id='warp_sub' width='33rem' v-model="visible" on-ok="handleOk1" @cancel="handleCancel(0)"
				v-dragModal :footer="null" :rules="rules" :keyboard='false' :maskClosable='false' 
				:dialog-style="{ top: '2px !important' }">
				<div class='mark-file'style="z-index: 2;">
					<div style="width: 31rem;">
						{{lang.newipo}}
					</div>
				</div>
			<div solt='title'></div>
			<div class='nonebor' style="z-index: 100;">
				<div @click='england = "cn"' :style='england == "cn"?"color:#0c8b96":""' title='中文'>中文</div>
				<div @click='england = "en"' :style='england == "en"?"color:#0c8b96":""' title='EN' style="border-left: 1px solid #999;margin-right: .7rem;">EN</div>
			</div>
			<div class='body_lis' :class="england=='en'?'landen':''" 
			style="z-index: 1;width: 31rem;position: relative;top: 1.45rem;padding-top: 2rem;margin: 0 auto 1.5rem;">
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" :rules='rules'
					hideRequiredMark>
					<div style="overflow: hidden;display: inline;">
					<a-form-model-item v-if='england=="cn"' :label="lang.comname" prop='cn_planned_company_name_cn'>
						<a-input v-model="form.cn_planned_company_name_cn" class='wart-t' @blur='handcn'/>
					</a-form-model-item>
					<a-form-model-item v-else :label="lang.comname" prop='cn_planned_company_name_en'>
						<a-input v-model="form.cn_planned_company_name_en" class='wart-t' @blur='handen'/>
					</a-form-model-item>
					<div class='warp_long'>
						<a-form-model-item :label="lang.nature" v-show='england=="cn"'
							prop='cn_planned_industry_name_cn'>
							<!-- <a-select v-model="form.cn_planned_industry_name_cn" class='warp_width'>
								<a-select-option v-for="(item) in khtypeArrs" :key="item.key + 'd'" :value="item.value">
									{{item.text}}
								</a-select-option>
							</a-select> -->
							<Situationall v-if='england=="cn"' v-model="form.cn_planned_industry_name_cn"
								:url='$api.getParamList' :openfirst='form.cn_planned_industry_name_cn&&england == "cn"'
								:valonce='JSON.parse(JSON.stringify(form)).cn_planned_industry_name_cn'
								:params='{"type":"industrys","cn_planned_industry_name_en":form.cn_planned_industry_name_en}'
								:style='"width: 100%;"'>
								<!-- :placeholder="'請選擇上市行業'" -->
							</Situationall>
							<!-- <a-input v-model="form.cn_planned_industry_name_cn" placeholder="請輸入上市行業" /> -->
						</a-form-model-item>
						<a-form-model-item v-show='england=="en"' :label="lang.nature"
							prop='cn_planned_industry_name_en'>
							<Situationall v-if='england=="en"' v-model="form.cn_planned_industry_name_en"
								:url='$api.getParamList' :openfirst='form.cn_planned_industry_name_cn&&england == "en"'
								:valonce='JSON.parse(JSON.stringify(form)).cn_planned_industry_name_en'
								:params='{"type":"industrys","cn_planned_industry_name_cn":form.cn_planned_industry_name_cn}'
								:style='"width: 100%;"'>
							</Situationall>
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label="lang.market" prop='plates_cn'>
							<a-select v-model="form.plates_cn" class='warp_width'>
								<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
									:value="item.value">{{england=="cn" ?item.text : item.entext}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class='warp_long'>
						<a-form-model-item :label="lang.status" prop='status_cn'>
							<a-select v-model="form.status_cn" class='warp_width'
								@change='handselefn(form.status_cn,"ruleForm")'>
								<a-select-option v-for="(item) in admintypeArr" :key="item.key + 'b'"
									:value="item.value">{{england=="cn" ?item.text : item.entext}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label="lang.subdata" prop='delivery_date'>
							<a-date-picker v-model="form.delivery_date" @change="handback('delivery_date')"
								:disabled-date="deliveryDate" class='warp_width' placeholder="" />
							<!-- placeholder="请输入遞表日期" -->
						</a-form-model-item>
					</div>
					<div id='on-center'>
						<a-form-model-item :label="lang.profile" prop='info'>
							<a-textarea v-model="form.info" :auto-size="{ minRows: 4, maxRows: 5 }"
								:maxLength='200' :disabled-date="deliveryDate"
								class='wart-t' @blur='handkong'/>
							<!-- placeholder="请输入公司業務"  -->
							<span
								style="color:#bfbfbf;position:absolute;bottom:-10px;right:10px;">{{form.info.length}}/200</span>
						</a-form-model-item>
					</div>
					<!-- <div style="width: 95.5%;border-top: 1px solid #d8d8d8;height: .6rem;"></div> -->
					<div class='warp_long'>
						<a-form-model-item v-if='england=="cn"' :label="lang.stockname"
							:prop='form.status_cn!==0?"stockname":""'>
							<a-input v-model="form.stockname" class='warp_width' />
						</a-form-model-item>
						<a-form-model-item v-else :label="lang.stockname" :prop='form.status_cn!==0?"stockname_en":""'>
							<a-input v-model="form.stockname_en" class='warp_width' />
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label="lang.stockcode" :prop='form.status_cn!==0?"stockcode":""'>
							<a-input v-model="form.stockcode" @blur='stockcodeFn("stockcode")' class='warp_width'
								:maxLength='5' />
						</a-form-model-item>
					</div>
					
					<div class='warp_long '>
						<a-form-model-item :label='lang.ldata' prop='listingdate'>
							<a-date-picker v-model="form.listingdate" type="date" @change="handback('listingdate')"
								:disabled-date="disabledDate" class='warp_width' placeholder="" />
							<!-- placeholder="请输入上市日期" -->
						</a-form-model-item>
					</div>
<div class='warp_long texright'>
						<a-form-model-item :label="lang.grey" >
							<!-- prop='anpantime' -->
							<a-date-picker v-model="form.anpantime" type="date" @change="handback('anpantime')"
								 class='warp_width' placeholder="" :disabled-date="deliveryDate"/>
								 <!-- :disabled='form.anpantime?true:false' -->
							<!--  placeholder="请输入暗盤日期" -->
						</a-form-model-item>
					</div>
					<div class='warp_long'>
						<a-form-model-item :label='lang.efee' prop='entryfee'>
							<a-input v-model="form.entryfee" class='warp_width' @blur='stockcodeFn("entryfee",1)' />
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label='lang.Board' prop='pergshu'>
							<a-input v-model="form.pergshu" class='warp_width' @blur='stockcodeFn("pergshu")' />
						</a-form-model-item>
					</div>
					<a-form-model-item :label="lang.Period" class="formItem" prop='application_open'>
						<a-date-picker  class='dateinput' v-model='form.application_open' placeholder=""
							:disabled-date="disabledDate" @change="handback('application_open')">
							<!-- placeholder="请输入啟示認購日期" -->
							<template slot="dateRender" slot-scope="current, today">
								<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
									{{ current.date() }}
								</div>
							</template>
						</a-date-picker>
						<div class='warp_a'>~</div>
						<a-date-picker   class='dateinput'  v-model='form.application_close'
							:disabled-date="applicationDate" @change="handback('application_close')" placeholder="">
							<!-- placeholder="请输入終止認購日期" -->
							<template slot="dateRender" slot-scope="current, today">
								<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
									{{ current.date() }}
								</div>
							</template>
						</a-date-picker>
					</a-form-model-item>
					<a-form-model-item :label="lang.price" class="formItem" prop='offer_price_l'>
						<a-input v-model="form.offer_price_l"  class='valinput' 
							@blur='stockcodeFn("offer_price_l",1)' />
						<div class='warp_a'>~</div>
						<a-input v-model="form.offer_price_h"  class='valinput' 
							@blur='stockcodeFn("offer_price_h",1)' />
					</a-form-model-item>
					<div class='warp_long'>
						<a-form-model-item :label="lang.sponsor" prop='baojianr'>
							<Situationall v-model="form.baojianr" :url='$api.getParamList' :params='{"type":"baojianr"}'
								:val='form.baojianrval' :style='"width:100%;"' class='warp_rightz' :zz='"zz"'></Situationall>
							<a-popover :visible="visibles" placement="top" trigger="click" :destroyTooltipOnHide="true"
								:overlayStyle="{width:'calc(25rem)'}" @visibleChange="moreEvent()"
								:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
								<template slot="content">
									<div>
										<div id='on-center'>
											<a-textarea v-model="form.baojianr" :auto-size="{ minRows: 4, maxRows: 5 }" @input="baofn"
												:placeholder="lang.cname" class='wart-t word-abc' />
										</div>
									</div>
								</template>
								<img title='點擊添加更多' src="@/image/images.png" style="z-index:1111;cursor: pointer;
								position: absolute;right: 0.5rem;width: .7rem;top: 0.2rem;" alt="" @click='fundefan'>
							</a-popover>
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label="lang.rate" >
							<!-- prop='multiple' -->
							<a-input v-model="form.multiple" class='warp_width' @blur='stockcodeFn("multiple")' />
						</a-form-model-item>
					</div>
					<div class='warp_long'>
						<a-form-model-item :label="lang.jeb" prop='jeb'>
								<div class="btnimg" @click='addopen'>
								<img :src="ipoAdmin?require('@/image/newadd.png'):require('@/image/newexcel.png')" alt="" class='imgbtn'
								style='position: relative;top: -0.2rem;'></div>
								<!-- <img :src="require('@/image/newexcel.png')" alt="" class='imgbtn' 
								style='position: relative;top: -0.1rem;' @click='addopen'> -->
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label="lang.dkbl" prop='loan_ratio'>
							<a-input v-model="form.loan_ratio" class='warp_width' disabled suffix='%'/>
						</a-form-model-item>
					</div>
					<div class='warp_long'>
						<a-form-model-item :label="lang.rs" prop='loan_days'>
							<a-input v-model="form.loan_days" class='warp_width' disabled/>
						</a-form-model-item>
					</div>
					<div class='warp_long texright'>
						<a-form-model-item :label="lang.lx" prop='gain'>
							<a-input v-model="form.gain" class='warp_width' disabled suffix="%"/>
						</a-form-model-item>
					</div>
					<div id='on-center1'>
						<a-form-model-item :label="lang.Prospectus" >
							<!-- prop='linkaddress' -->
								<a-input v-model="form.linkaddress" class='wart-t' />
						</a-form-model-item>
					</div>
					</div>
				</a-form-model>
				<div class='warp_button' style="display:flex;align-items: center;margin: 1rem auto;">
					<button type="button" class="qxBtn" @click='handleCancel'>{{lang.cancel}}</button>
					<button type="button" class="qdBtn" @click="handleOk('ruleForm')"
						:loading="loading">{{lang.save}}</button>
				</div>
				<a-modal v-show='!ishand' id='warp_subs' width='75rem' v-model="visibleadd" on-ok="handleOk1"
				 @cancel="visibleadd = false"  :dialog-style="{ top: '7vh' }"
				 v-dragModal :footer="null" :rules="rules" :keyboard='false' :maskClosable='false'>
								<div class='mark-file'style="z-index: 2;">
									<div style="width: 73rem;">
										<!-- {{lang.jeb}} -->
										申請認購的香港發售股份數目及應繳股款
									</div>
								</div>
							<div solt='title'></div>
							<div class='body_lis' :class="england=='en'?'landen':''" 
							style="z-index: 1;width: 73rem;position: relative;top: 1.45rem;padding-top: 2rem;margin: 0 auto 1.5rem;">
							<div id='text_title' style='width: 100%;margin: 0 auto .2rem;'>
								<div  v-for='i in 4'>
									<div>
										申請認購的
										<br>香港發售<br>
										股份數目
									</div>
									<div>
										<br>
										申請時<br>
										應繳款項
									</div>
								</div>
							</div>
							<div id='warp_subs_from'>
								<div class='mycol_div6' v-for='(v,i) in fouten'>
									<div class='id_nav' v-for='(k,ind) in v' :key='ind+"223366"'
									 style='width: 100%;display: flex;justify-content: space-between;'>
										<div class='mydiv'>
											<!-- <a-tooltip :trigger="['hover']" placement="top" overlay-class-name="numeric-input">
											<span v-if="k.pricekey.length>10" slot="title" style="font-size: .8rem;">
											      {{ k.pricekey }}
											    </span>  -->
											<a-input v-model="k.pricekey" class='warp_width'
											 @input='numarrfn(ind,"pricekey",i,0)'  :disabled='!ipoAdmin'
											 @pressEnter='servicechange(ind,k.pricekey,i)'
											 @blur='servicechange(ind,k.pricekey,i)'></a-input>
											 <!-- </a-tooltip> -->
										</div>
										<div class='mydiv'>
											<!-- <a-tooltip :trigger="['hover']" placement="top" overlay-class-name="numeric-input">
											<span v-if="k.priceval.length>10" slot="title" style="font-size: .8rem;">
											      {{ k.priceval }}
											    </span>  -->
											<a-input v-model="k.priceval" class='warp_width' 
											:disabled='!ipoAdmin'
											@blur='numarrfn(ind,"priceval",i,2)'
											@pressEnter='numarrfn(ind,"priceval",i,2)'></a-input>
											<!-- </a-tooltip> -->
										</div>
									</div>
								</div>
							</div>
								<div class='warp_button' style="margin-top: 2rem;display: flex;justify-content: space-between;">
									<div class='six_div'>
											<div>
												公司名稱: {{form.cn_planned_company_name_cn}}
											</div>
											<div>
												招股價: 
												<span v-if='form.offer_price_h'>{{form.offer_price_h}}</span>
												<span v-else-if='form.offer_price_l'>{{form.offer_price_l}}</span>
											</div>
										<br>
										<div>
											交易佣金: {{ServiceCharge.commission}}
											</div><div>
											交易微費: {{ServiceCharge.Micro_fee}}
											</div><div>
											交易費:	  {{ServiceCharge.Transaction_fee}}
											</div><div>
											財匯局交易徵費:	 {{ServiceCharge.Matimp}}  
										</div>
									</div>
									<button type="button" class="qdBtn" @click="visibleadd = false"
										:loading="loading">
										<!-- 保存 -->
										{{lang.confirm}}
										</button>
								</div>
							</div>
						</a-modal>
			</div>
		</a-modal>
		<!-- <minhand v-if='ishand' @child='fundefan' :ishand='ishand' :forms='form'></minhand> -->
		
	</div>
</template>
<script>
	import App from '@/assets/app.js';
	import minhand from './minhand.vue'
	import iconmin from './iconmin.vue'
	import searchope from './searchope.vue'

	export default {
		props: ['isopen'],
		components: {
			minhand,
			iconmin,
			searchope
		},
		data() {
			return {
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				ServiceCharge:{
					commission:'1%',
					Micro_fee:'0.0027%',
					Transaction_fee:'0.00565%',
					Matimp:'0.00015%',
				},
				fouten:{
					'12':[],
					'24':[],
					'36':[],
					'48':[],
				},
				arr:[{
					loan_days:'',
					gain:''
				}],
				pdfUrl:'',
				visibleadd:false,
				visibles: false,
				england: 'cn',
				lang: '',
				ishand: false,
				loading: false,
				visible: this.isopen,
				labelCol: {
					span: 5
				},
				wrapperCol: {
					span: 18
				},
				zerorules: {
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_company_name_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_industry_name_en: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					linkaddress:[{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				allrules: {
					stockcode: [{
						required: true,
						message: ' ',
						trigger: ['blur', 'change']
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offer_price_l: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offer_price_h: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					pergshu: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					application_open: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					application_close: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					listingdate: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					entryfee: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_industry_name_en: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_company_name_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					baojianr: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					anpantime: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					multiple: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],linkaddress:[{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				stockrules: {
					stockcode: [{
						required: true,
						message: ' ',
						trigger: ['blur', 'change']
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],linkaddress:[{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				rules: {},
				form: {
					"pricelist":[
					   {"pricekey":"",
					    "priceval":"" 
					   },
					  ],
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					linkaddress:'',
					pricefileid :'',
					loan_ratio :'',	// 比率
					loan_days :'',	// 日數
					gain :'',		// 利息
					// "adminid": "", // 錄入人唯一標識
				},
				admintypeArrs: [{
						text: '主板',
						entext: 'Mainboard',
						value: '0'
					},
					{
						text: '創業板',
						entext: 'GEM board',
						value: '1'
					},
				],
				admintypeArr: [{
									text: '處理中',
										entext:'Processing',
										value: '0'
									},
									{
										text: '認購中',
										entext:'Subscribing',
										value: '1'
									},
									{
										text: '待上市',
										entext:'Planned IPO',
										value: '2'
									},
									{
										text: '已上市',
										entext:'Listed IPO',
										value: '3'
									},
									{
									   text: '已除牌',
										entext:'Delisted',
										value: '4'
									},
									{
									    text: '已失效',
										entext:'Expired',
										value: '5'
									}	
									],
			};
		},
		watch: {
			england: {
				immediate: true,
				handler(ev) {
					this.lang = this.england == 'cn' ? this.$big5.sub : this.$eng.sub
				},
			}
		},
		created() {
			let _this= this;
			_this.foutenfn()
		},
		mounted() {
			this.rules = this.allrules
		},
		methods: {
			/**
			 * 去換行
			 * 文字間的空格變成一個
			 * 去文字左右的空格
			 */
			handkong(){
				this.form.info = this.form.info.replace(/<\/?.+?>/g,""); 
				this.form.info = this.form.info.replace(/[\r\n]/g, ""); 
				this.form.info = this.form.info.replace(/ +/g, ' ');
				this.form.info = this.form.info.trim()
			},
			handcn(){
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/<\/?.+?>/g,""); 
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/[\r\n]/g, ""); 
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.trim()
			},
			handen(){
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/<\/?.+?>/g,""); 
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/[\r\n]/g, ""); 
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.trim()
			},
			
			numgeshihua(ins,c, d, t){
			var n = ins, 
			    c = isNaN(c = Math.abs(c)) ? 2 : c, 
			    d = d == undefined ? "." : d, 
			    t = t == undefined ? "," : t, 
			    s = n < 0 ? "-" : "", 
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
			    j = (j = i.length) > 3 ? j % 3 : 0;
			   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
			 },
			addopen(){
				if(this.form.cn_planned_company_name_cn && (this.form.offer_price_h||this.form.offer_price_l)){
					this.visibleadd = true
				}else{
					this.$message.warning(this.lang.pln+this.lang.comname+','+this.lang.price)
				}
			},
			foutenfn(){
				for(let key in this.fouten){
					for(let a=0;a<12;a++){
						this.fouten[key].push({
							'pricekey':'',
							'priceval':''
						})
					}
				}
			},
			servicechange(i,v,key){
				let numv = v.split(',').join('')
				if(v){
					let num = numv *(this.form.offer_price_h||this.form.offer_price_l)*(.01+0.000027+0.0000565+1+.0000015)
					this.$set(this.fouten[key][i],'priceval',this.numgeshihua(num))
				}else{
					this.$set(this.fouten[key][i],'priceval','')
				}
			},
			numarrfn(ind,key,v,end){
				let arr = JSON.parse(JSON.stringify(this.fouten))
				let str = arr[v][ind][key].split(',').join('')
				if(str){
					if(isNaN(str)){
						this.$set(arr[v][ind],key,'')
					}else{
						this.$set(arr[v][ind],key,this.numgeshihua(str,end))
					}
					this.fouten = arr
				}
			},
			pdfEvent(record){
				// location.href= this.pdfUrl
			},
		
			fundefan() {
				// this.visible = !this.visible
			},

			//彈出前操作
			moreEvent() {
				this.visibles = !this.visibles
				this.$set(this.form, 'baojianrval', JSON.parse(JSON.stringify(this.form.baojianr)))
			},
			//禁止選擇
			deliveryDate(current) {
				return current && current > new Date(this.form.listingdate)
			},
			//禁止選擇(小于)
			disabledDate(current) {
				return current && current < new Date(this.getNextDate(this.form.delivery_date, 1))
			},
			//禁止選擇(大于)
			applicationDate(current) {
				return current && current > new Date(this.form.anpantime)
			},
			stockcodeFn(value, zero) {
				this.form[value] = App.isnumdate(this.form[value], zero)
				if(this.form.offer_price_l&&this.form.offer_price_h){
					if(this.form.offer_price_l*1>this.form.offer_price_h*1){
						let num = this.form.offer_price_h
						this.form.offer_price_h = this.form.offer_price_l
						this.form.offer_price_l= num
					}
				}
			},
			handselefn(val, ruleForm) {
				if (val == 0) {
					this.rules = this.zerorules
				} else if (val == 1 || val == 2) {
					this.rules = this.allrules
				} else if (val == 3) {
					this.rules = this.stockrules
				}
				let obj = JSON.parse(JSON.stringify(this.form))
				this.$refs[ruleForm].resetFields();
				this.form = obj
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.form[dateTime1])
				var formatDate2 = new Date(this.form[dateTime2])
				console.log(formatDate1 , formatDate2,formatDate1 > formatDate2)
				if (formatDate1 > formatDate2) {
					this.form[dateTime1] = '';
				}
			},
			baofn(){
				this.form.baojianr = this.form.baojianr.replace(/[,]+/g, '')
			},
			handback(val) {
				this.form[val] = this.form[val] ? App.oDate.secsTime3(this.form[val]._d) : ''
				//（遞表日期）》啟示認購日期 》 終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'application_open') {
					if (this.form.application_close && this.form.application_open) {
						this.compareDate('application_open', 'application_close')
					}
				}
				//遞表日期》上市日期
				if (val == 'delivery_date' || val == 'listingdate') {
					if (this.form.delivery_date && this.form.listingdate) {
						this.compareDate('delivery_date', 'listingdate')
						// anpantime
					}
				}
				//（遞表日期）》啟示認購日期
				if (val == 'delivery_date' || val == 'application_open') {
					if (this.form.delivery_date && this.form.application_open) {
						this.compareDate('delivery_date', 'application_open')
					}
				}
				//終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'listingdate') {
					if (this.form.application_close && this.form.listingdate) {
						this.compareDate('application_close', 'listingdate')
					}
				}


				//暗盤日期 獲取上市日期前一天
				if (this.form.listingdate) {
					// this.form.anpantime = this.getNextDate(this.form.listingdate, -1)
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'application_close') {
					if (this.form.anpantime && this.form.application_close) {
						this.compareDate('application_close', 'anpantime')
					}
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'delivery_date') {
					if (this.form.anpantime && this.form.delivery_date) {
						this.compareDate('delivery_date', 'anpantime')
					}
				}
			},
			//前后一天
			getNextDate(date, day) {
				var dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			},
			getCurrentStyle(current, today) {
				const style = {};
				if (current.date() === 1) {
					style.border = '1px solid #1890ff';
					style.borderRadius = '50%';
				}
				return style;
			},
			handleOk1() {
				console.log('on-ok')
			},
			handleOk(ruleForm) {
				let numarr = JSON.parse(JSON.stringify(this.fouten))
				let brr=[];
				for(let key in numarr){
					numarr[key].map((val,i)=>{
					if(val['pricekey']){
						val['pricekey'] = val['pricekey'].split(',').join('')
						if(val['priceval']){
							val['priceval'] = val['priceval'].split(',').join('')
								brr.push(val)   
						}
					}
				})
				}
				this.form.pricelist = brr;
				
				this.$refs.ruleForm.validate(valid => {
					if (this.form.status_cn < 3) {
					if (!this.form.cn_planned_company_name_en || !this.form.cn_planned_industry_name_en) {
						this.$message.error('請填寫英文數據');
						return
					}
				}
				if (this.form.status_cn == 3||this.form.status_cn == 1){
					if (!this.form.stockname_en) {
						this.$message.error('請填寫英文股票名称');
						return
					}
				}/*  */

				if (valid) {
						this.form.token = this.$store.state.token
						this.$ajax({
							method: 'post',
							url: this.$api.newIpoSelling,
							headers: {
								token: this.$store.state.token,
							},
							data: this.form
						}).then(res => {
							console.log(res.data.qmiscode, res.data.qmiscode == 1000)
							if (res.data.qmiscode == 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					}
				})
			},
			handleCancel(ev) {
				console.log(ev)
				 // if(ev == 0){
					//  this.$confirm({
					//         title: '是否關閉添加',
					//         // content: 'When clicked the OK button, this dialog will be closed after 1 second',
					// 		okText: '關閉',
					// 		cancelText: '取消',
					//         onOk() {
					//           return new Promise((resolve, reject) => {
					//             this.$emit('child', 0)
					//           }).catch(() => console.log('Oops errors!'));
					//         },
					//         onCancel() {},
					//       });
				 // }else{
					 
				 // }
				 this.$emit('child', 0)
			},

		},
	};
</script>
